import { PLUGINS_KEYS } from "../../../other/constants/PluginKeys.jsx";
import { getOriginalRecord } from "../../../other/utils/utils.jsx";
import { createScheduleFileDropPluginClass } from "./createScheduleFileDropPluginClass.js";

/** File drop onto schedule timeline event bars (.b-sch-event-wrap). */
export default createScheduleFileDropPluginClass({
  pluginName: PLUGINS_KEYS.swivuEventFileDrop,
  getRootElement: (plugin) => plugin.client?.timeAxisSubGridElement,
  findDropTarget: (target) => target?.closest?.(".b-sch-event-wrap") ?? null,
  resolveTask: (plugin, eventWrap) => {
    const scheduler = plugin.client;
    const eventRecord =
      (typeof scheduler.resolveEventRecord === "function"
        ? scheduler.resolveEventRecord(eventWrap)
        : null) ||
      (eventWrap.dataset?.eventId
        ? scheduler.eventStore?.getById(eventWrap.dataset.eventId)
        : null);

    return getOriginalRecord(eventRecord?.task);
  },
});
